module.exports = __webpack_public_path__ + "f7aac68f5fd8b7d684a907348424cbe9.jpg";